module.exports = __webpack_public_path__ + "img/wral.8e96456.png";